import { default as MUIButton } from "@material-ui/core/Button";
import PropTypes from "prop-types";

const Button = ({ children, onClick, ...opts }) => {
  return (
    <MUIButton onClick={onClick} {...opts}>
      {children}
    </MUIButton>
  );
};

export default Button;

Button.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
};
